import perfectDayLogoUrl from "@assets/perfect-day-logo.png"

export default function PerfectDayLogo() {
  return (
    <img src={perfectDayLogoUrl} alt="perfect day logo" className="h-12 w-10" />
  )
}
